import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../types/interfaces';

type TBannerAction = 'show_sopr' | 'click_sopr';

const page = {
  pageType: 'ListingJK',
  listingType: 'list',
  siteType: 'desktop',
  extra: {
    trap_type: 'new_building',
    bannerName: 'purchase_giveaway',
    trapid: 'purchase_giveaway',
    source: 'ListingJK',
  },
} as const;

export function trackBannerShow(jsonQuery: IJsonQuery): void {
  trackBannerEvent(jsonQuery, 'show_sopr');
}

export function trackBannerClick(jsonQuery: IJsonQuery): void {
  trackBannerEvent(jsonQuery, 'click_sopr');
}

function trackBannerEvent(jsonQuery: IJsonQuery, action: TBannerAction): void {
  ca('eventSite', {
    name: 'oldevent',
    action,
    category: 'trap',
    label: 'purchase_giveaway_banner',
    sc: jsonQuery,
    useLastProducts: true,
    page,
  });
}
